export const STEPS_CONTENT: { stepNumber: number; title: string; content: string }[] = [
  {
    stepNumber: 1,
    title: 'Bestandsaufnahme',
    content: 'Wir erörtern den Bedarf und das Ausmaß Ihres Projekts und verschaffen uns einen detaillierten Überblick.'
  },
  {
    stepNumber: 2,
    title: 'Empfehlung',
    content: 'Anhand unseres Austausches empfehlen wir einen Lösungsweg, passend zu Ihren Anforderungen und Ihrem Budget.'
  },
  {
    stepNumber: 3,
    title: 'Angebot',
    content: 'Wenn Sie mit uns zusammen arbeiten wollen, bekommen Sie ein unverbindliches Angebot.'
  },
  {
    stepNumber: 4,
    title: 'Onboarding',
    content: 'Sobald das Angebot angenommen ist, holen wir Sie an Bord und starten gemeinsam durch!'
  }
]
